import { render, staticRenderFns } from "./AddVendorcategory.vue?vue&type=template&id=910b1074"
import script from "./AddVendorcategory.vue?vue&type=script&lang=js"
export * from "./AddVendorcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports